import calculateStatus from './calculate-status.js';
import getConnectableFlags from './connectable-device.js';

/**
 * @typedef { import('synapse-common-device-service').Device } Device
 * @typedef { import('../types/adapted-device').AdaptedDevice } AdaptedDevice
 */

/**
 *
 * @param { Device[] } devices
 * @returns { AdaptedDevice[] }
 */
export function formatToAdaptedDevices(devices) {
  return devices.map(device => ({
    ...device,
    connectable: getConnectableFlags(device),
  }));
}

/**
 *
 * @param {import('synapse-common-device-service').Device[]} devices
 * @returns
 */
export function formatCDSDevicesToAdaptedDevices(devices = []) {
  return devices.map(device => ({
    ...device,
    lastLoggedInUser: device?.lastLoggedInUser?.userName ?? null,
    version: device.clientVersion ?? null,
    status: calculateStatus(device.status, device.inSession),
    deviceGroupId: device.deviceGroupId && device.deviceGroupId !== 'null' ? device.deviceGroupId : null,
    connectable: getConnectableFlags(device),
    // TODO: (geri): remove milliseconds format after CDS release and updated most of the device in DB NG-21884
    lastAccess: getMSTimestamp(device.lastAccess),
    deviceName: device.deviceName ?? device.hostName,
  }));
}

function getMSTimestamp(timestamp) {
  if (!timestamp) {
    return null;
  }

  if (`${timestamp}`.length === 10) {
    // timestamp in seconds
    return timestamp * 1000;
  }

  return timestamp;
}

/**
 *
 * @param {Device} device
 * @returns {AdaptedDevice}
 */
export function formatToAdaptedDevice(device) {
  return { ...device, connectable: getConnectableFlags(device) };
}
